<template>
  <div class="entry-layout">
    <progress-bar/>
    <router-view v-if="getUserLoaded"></router-view>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import ProgressBar from "../parts/ProgressBar";

export default {
  name: "EntryLayout",
  components: {
    ProgressBar
  },
  computed: {
    ...mapGetters([
      'getUserLoaded'
    ])
  },
}
</script>
